// Legacy and feedback buttons
import Cookies from "js-cookie";

const ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};
ready(() => {
  const noticeButtons = document.getElementById("notice-buttons");
  if (noticeButtons) {
    const feedbackLink = document.createElement("a");
    feedbackLink.setAttribute(
      "href",
      "mailto:services@longnow.org?subject=Website%20feedback"
    );
    feedbackLink.setAttribute("class", "button");
    feedbackLink.setAttribute("target", "_blank");
    feedbackLink.setAttribute("rel", "noopener");
    feedbackLink.textContent = "Send feedback";
    noticeButtons.appendChild(feedbackLink);
    const switchButton = document.createElement("button");
    switchButton.setAttribute("class", "button");
    switchButton.textContent = "Switch to legacy site";
    noticeButtons.appendChild(switchButton);
    switchButton.addEventListener("click", (e) => {
      gtag("event", "switched_to_legacy");
      Cookies.set("legacy", "1");
      window.location.reload();
    });
  }
});
